import styled from 'styled-components';
import { Button } from '@leasequery/lq.react-component-library';

const CommandButton = styled(Button)`
  padding: 0.5rem;
  min-width: 3.2rem;
  min-height: 3.2rem;
`;

export { CommandButton };
